let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("39Zx1")).then(() => parcelRequire('2kjD7'));